/* TR Product tabs: sections/tr-product-tabs.liquid
   - Tabs: click / arrow keys / Home / End (only when there are 2+ tabs)
   - Card row arrows (desktop): scroll by the visible width, hide at the ends */

if (!customElements.get('tr-product-tabs')) {
  class TrProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-tr-tab]')];
      this.panels = [...this.querySelectorAll('[data-tr-tab-panel]')];

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (event) => this.onTabKey(event, i));
      });

      this.panels.forEach((panel) => this.initSlider(panel));

      // Theme editor: selecting a tab block opens that tab
      this.addEventListener('shopify:block:select', (event) => {
        const i = this.tabs.indexOf(event.target);
        if (i > -1) this.select(i);
      });
    }

    onTabKey(event, i) {
      const last = this.tabs.length - 1;
      const target = { ArrowRight: i === last ? 0 : i + 1, ArrowLeft: i === 0 ? last : i - 1, Home: 0, End: last }[event.key];
      if (target === undefined) return;
      event.preventDefault();
      this.select(target);
      this.tabs[target].focus();
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
        if (i === index) panel.updateArrows?.();
      });
    }

    initSlider(panel) {
      const track = panel.querySelector('[data-tr-track]');
      const prev = panel.querySelector('[data-tr-prev]');
      const next = panel.querySelector('[data-tr-next]');
      if (!track || !prev || !next) return;

      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      };

      let ticking = false;
      track.addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            update();
            ticking = false;
          });
        },
        { passive: true }
      );

      const step = () => {
        const slide = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const perView = Math.max(1, Math.floor(track.clientWidth / (slide.offsetWidth + gap)));
        return perView * (slide.offsetWidth + gap);
      };

      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

      panel.updateArrows = update;
      update();
    }
  }

  customElements.define('tr-product-tabs', TrProductTabs);
}
